import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import Button from 'react-bootstrap-button-loader';
import { ButtonTrash } from '../../../common/buttons';

import {
  InputField,
  SelectField,
  required,
  number
} from '../../../form';

class FilterQuery extends Component {
  getOperatorOptions(_query, filterIndex, queryIndex) {
    const { formValues } = this.props;

    if (formValues && ['bid', 'date'].includes(formValues.and[filterIndex].or[queryIndex].term.field)) {
      return [
        { label: '', value: null },
        { label: 'Less than (<)', value: 'lt' },
        { label: 'Less than or equal (<=)', value: 'lteq' },
        { label: 'Equal to (=)', value: 'eq' },
        { label: 'Not equal to (!=)', value: 'not_eq' },
        { label: 'Greater than or equal (>=)', value: 'gteq' },
        { label: 'Greater than (>)', value: 'gt' },
      ];
    }

    return [
      { label: '', value: null },
      { label: 'Equal to (=)', value: 'eq' },
      { label: 'Not equal to (!=)', value: 'not_eq' },
      { label: 'In', value: 'in' },
      { label: 'Not In', value: 'not_in' },
    ];
  }

  renderValueField(query, filterIndex, queryIndex) {
    const { formValues } = this.props;
    const validations = formValues && formValues.and[filterIndex].or[queryIndex].term.field === 'bid' ? [required, number] : [required];
    const fieldType = formValues && formValues.and[filterIndex].or[queryIndex].term.field === 'bid' ? 'number' : 'text';

    return (
      <Col md={4}>
        <Field
          type={fieldType}
          name={`${query}.term.value`}
          label='Value'
          component={InputField}
          validate={validations}
        />
      </Col>
    );
  }
  render() {
    const { fields } = this.props;

    return (
      <div>
        {fields.map((query, index, props) => {
          const operatorOptions = this.getOperatorOptions(query, +props.name.match(/\d+/)[0], index);
          return (
            <Row key={index} style={{ margin: '0 15px 0 15px' }}>
              <Col md={3}>
                <Field
                  type='text'
                  name={`${query}.term.field`}
                  label='Field'
                  component={SelectField}
                  options={[
                    { label: '', value: null },
                    { label: 'Bid', value: 'bid' },
                    { label: 'URL', value: 'url' },
                    { label: 'City', value: 'city' },
                    { label: 'State', value: 'state' },
                    { label: 'Date', value: 'date' },
                    { label: 'Title', value: 'title' },
                    { label: 'Status', value: 'status' },
                    { label: 'Company', value: 'company' },
                    { label: 'Country', value: 'country' },
                    { label: 'Category', value: 'category' },
                  ]}
                  normalize={field => (field ? field.value : field)}
                  validate={[required]}
                />
              </Col>
              <Col md={3}>
                <Field
                  type='text'
                  name={`${query}.term.operator`}
                  label='Inequity'
                  component={SelectField}
                  options={operatorOptions}
                  normalize={field => (field ? field.value : field)}
                  validate={[required]}
                />
              </Col>
              { this.renderValueField(query, +props.name.match(/\d+/)[0], index) }
              <Col md={2} style={{ marginTop: '30px' }}>
                <Button
                  bsSize='xs'
                  onClick={() => fields.push({ term: { field: '', operator: '', value: null } })}
                  bsStyle='success'
                  className='m-l-xs'
                >
                  OR
                </Button>
                <ButtonTrash
                  bsSize='xs'
                  onClick={() => fields.remove(index)}
                  disabled={fields.length === index + 1 && fields.length === 1}
                  bsStyle='danger'
                  className='m-l-xs'
                />
              </Col>
            </Row>
          );
        })}
      </div>   
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { form } = state;
  
  if (form[ownProps.meta.form] && form[ownProps.meta.form].values) {
    const filters = form[ownProps.meta.form].values;
  
    return { formValues: filters };
  }

  return { formValues: [] };
};

export default connect(mapStateToProps)(FilterQuery);
